module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-year-2027-5d954e50b2d5bc55aecfb9dabb8d8d90.svg";